export enum TipoProgramaList {
  UniaoFazAVida = 'uniaoFazAVida',
  CooperativaEscolar = 'cooperativaEscolar',
  JornadaEducacao = 'jornadaEducacao',
}

export enum TipoPrograma {
  UniaoFazAVida = '0',
  CooperativaEscolar = '1',
  JornadaEducacao = '2',
}

export enum EscolaEditTabs {
  Informacoes = "informacoes",
  ProgramasEducacionais = "programas-educacionais",
}
